//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HeadBar from '../HeadBar/HeadBar';
import {OrderProxy} from '@/http/RequestProxy.class';

const orderProxy = new OrderProxy();

export default {
  name: 'bind-new-coupon',
  components: {
    HeadBar,
  },
  props: {
    isShow: Boolean,
  },
  data(){
    return {
      couponCode: '',   // 优惠券码
    };
  },
  methods: {
    onBack(){
      this.$emit('on-close');
    },

    /** 提交优惠券绑定 */
    onBindCoupon(){
      if(this.couponCode){
        const params = {
          type: 3,
          coupon_sn: this.couponCode,
          is_bind: 1,
        };

        this.$vux.loading.show();
        orderProxy.bindNewCoupon(params)
          .then(resp => {
            if(resp){
              this.onBack();
              this.$emit('on-bind-coupon', resp.data);
            }

            this.$vux.loading.hide();
          });
      }else{
        // 请输入优惠码
        this.$vux.toast.show(this.$i18n.t('hotel.WRITE_PREFERETIAL_CODE'));
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/Coupon/BindNewCoupon.vue